import { economyConfig } from '../config/economyConfig';

/**
 * Staff type definitions (spec section 14). Salaries come from economyConfig so
 * there is a single source of truth for balance. `role` documents the primary
 * effect; the numeric effect magnitudes live in economyConfig.STAFF_EFFECTS and
 * are applied by StaffEngine.
 */
export interface StaffTypeDef {
  id: string;
  name: string;
  salary: number; // monthly
  role: string;
}

export const STAFF_TYPES: Record<string, StaffTypeDef> = {
  cashier: {
    id: 'cashier',
    name: 'Cashier',
    salary: economyConfig.STAFF_SALARY.cashier,
    role: 'Speeds up payment throughput',
  },
  security: {
    id: 'security',
    name: 'Security',
    salary: economyConfig.STAFF_SALARY.security,
    role: 'Raises security, reduces theft',
  },
  cleaner: {
    id: 'cleaner',
    name: 'Cleaner',
    salary: economyConfig.STAFF_SALARY.cleaner,
    role: 'Raises cleanliness',
  },
  manager: {
    id: 'manager',
    name: 'Manager',
    salary: economyConfig.STAFF_SALARY.manager,
    role: 'Boosts efficiency & other staff',
  },
  technician: {
    id: 'technician',
    name: 'Technician',
    salary: economyConfig.STAFF_SALARY.technician,
    role: 'Reduces maintenance cost',
  },
};

/** Order shown in the staff hiring panel. */
export const HIREABLE_STAFF: string[] = [
  'cashier',
  'security',
  'cleaner',
  'manager',
  'technician',
];

export function getStaffType(id: string): StaffTypeDef | undefined {
  return STAFF_TYPES[id];
}
